exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".MailContactImage1-a{display:block;margin:0 auto}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/MailContactImage1/src/components/contents/MailContactImage1/MailContactImage1.s.scss"],"names":[],"mappings":"AAGE,qBACE,cAAc,AACd,aAAc,CACf","file":"MailContactImage1.scss","sourcesContent":["@import '~scss/variables';\n\n.MailContactImage1 {\n  &-a {\n    display: block;\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/MailContactImage1/MailContactImage1.scss
// module id = 1028
// module chunks = 110